export const appendFileToBrowser = (data: any, fileName: string) => {
  const blobUrl = window.URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName;

  // Append to the DOM and trigger the download
  document.body.appendChild(link);
  link.click();

  // Clean up and remove the link
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
};

export async function blobUrlToFile(blobUrl: string, fileName: string): Promise<File> {
  // Fetch the blob data from the blob URL
  const response = await fetch(blobUrl);
  if (!response.ok) {
    throw new Error("Network response was not ok.");
  }

  // Get the blob data
  const blobData: Blob = await response.blob();

  // Create and return a File object
  return new File([blobData], fileName, { type: blobData.type });
}

export function readFile(file: File): Promise<string> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result?.toString() ?? ""), false);
    reader.readAsDataURL(file);
  });
}
